import { de } from './de';
import { en } from './en';

export const locales = {
  de,
  en
};

export const defaultLocale = 'de';
export const supportedLocales = ['de', 'en'];

export const getLocale = (lang) => {
  return locales[lang] || locales[defaultLocale];
};

export { de, en };
